import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html',
  styleUrls: ['./download-file.component.css']
})
export class DownloadFileComponent implements OnInit {

  constructor(private commonService: CommonService) { }

  async ngOnInit() {
    this.commonService.download("Account").subscribe(
      data => {
        let binaryData = [];
        binaryData.push(data);
        const downloadedFile = new Blob(binaryData, { type: data.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "apple-app-site-association";
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      },
    );
  }

}
